import { Inject, Injectable } from '@angular/core';
import { BarcodeInput } from './barcode-input.type';
import { BarcodeModuleConfig, BARCODE_MODULE_CONFIG } from './barcode.config';

@Injectable()
export class VoucherBarcodeService {
  constructor(
    // private http: HttpClient,
    @Inject(BARCODE_MODULE_CONFIG)
    readonly config: BarcodeModuleConfig,
  ) {}

  getVoucher(barcode: BarcodeInput) {
    const url = `${this.config.url}?code=${barcode.code}&width=${barcode.width}&height=${barcode.height}`;
    return url;
  }
}
